import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import Logo from "../assets/img/logo.svg";
import { TiSocialGithub, TiSocialLinkedin } from "react-icons/ti";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // if height of how much scrolled is bigger than 50
      if (window.scrollY > 50) {
        setScrolled(true);
      }
      setScrolled(false);
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onUpdateActiveLink = (link) => {
    setActiveLink(link);
  };

  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
          <img src={Logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="#home"
              onClick={() => onUpdateActiveLink("home")}
              className={
                activeLink === "home" ? "active navbar-link" : "navbar-link"
              }
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="#skills"
              onClick={() => onUpdateActiveLink("skills")}
              className={
                activeLink === "skills" ? "active navbar-link" : "navbar-link"
              }
            >
              Skills
            </Nav.Link>
            <Nav.Link
              href="#projects"
              onClick={() => onUpdateActiveLink("projects")}
              className={
                activeLink === "projects" ? "active navbar-link" : "navbar-link"
              }
            >
              Projects
            </Nav.Link>
            <Nav.Link
              href="#history"
              onClick={() => onUpdateActiveLink("history")}
              className={
                activeLink === "history" ? "active navbar-link" : "navbar-link"
              }
            >
              History
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a
                href="https://github.com/suzuka4316"
                rel="noopener noreferrer"
                target="_blank"
              >
                <TiSocialGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/suzukafukami"
                rel="noopener noreferrer"
                target="_blank"
              >
                <TiSocialLinkedin />
              </a>
            </div>
            <a className="email" href="mailto:suzuka.fukami@gmail.com">
              <span>Let's connect</span>
            </a>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
